import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';

export const ActionCommandsHeader = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        px: { xs: 2, sm: 3, md: 4 },
        py: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        position: 'sticky',
        top: 0,
        zIndex: 1
      }}
    >
      <IconButton
        size="small"
        onClick={() => navigate('/settings/administration')}
      >
        <ArrowBackIcon />
      </IconButton>
      <Typography
        variant="h5"
        component="h1"
        sx={{
          fontWeight: 600,
          color: theme.palette.primary.main
        }}
      >
        {t('settings:administration.tools.actionCommands.title')}
      </Typography>
    </Box>
  );
};
